var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"error-page",class:{
		'mobile': _vm.mobileMode,
		'desktop': !_vm.mobileMode,
		'standalone': true,
	}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-header"},[_c('h1',{staticClass:"page-title"},[_vm._v("404")])])}]

export { render, staticRenderFns }